import { render, staticRenderFns } from "./MuonitusTapahtuma.vue?vue&type=template&id=56e08b1b"
import script from "./MuonitusTapahtuma.vue?vue&type=script&lang=js"
export * from "./MuonitusTapahtuma.vue?vue&type=script&lang=js"
import style0 from "./MuonitusTapahtuma.vue?vue&type=style&index=0&id=56e08b1b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports